import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ml-2 list-disc list-inside" }

import { recordTypes } from '@/common/recordTypes';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import MetaTags from '@/components/MetaTags.vue';
import SearchWithHiddenContentPage from '@/components/pages/SearchWithHiddenContentPage.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "DNS Lookup",
        description: "Find all DNS records for a domain name with this online tool. Nslookup shows A, AAAA, CNAME, TXT, MX, SPF, NS, SOA and more.",
        url: "https://www.nslookup.io/",
        img1024x512: "https://www.nslookup.io/img/social-1024x512.png",
        img1200x630: "https://www.nslookup.io/img/social-1200x630.png"
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"WebSite\", \"url\": \"https://www.nslookup.io/\", \"potentialAction\": { \"@type\": \"SearchAction\", \"target\": \"https://www.nslookup.io/domains/{search_term_string}/dns-records/\", \"query-input\": \"required name=search_term_string\" } } ", -1)
        ]))]),
        _: 1
      }))
    ])),
    _createVNode(SearchWithHiddenContentPage, {
      domainSearchToUrl: (domain) => `/domains/${domain}/dns-records/`
    }, {
      "search-explanation": _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("span", { "data-ccpa-link": "1" }, null, -1)),
        _cache[2] || (_cache[2] = _createTextVNode(" Find all DNS records for a domain name using this online tool. For example, try ", -1)),
        _createVNode(DnsRecordsLink, {
          domain: "wikipedia.org",
          class: "text-blue-600 hover:text-blue-800 hover:underline"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" or ", -1)),
        _createVNode(DnsRecordsLink, {
          domain: "www.twitter.com",
          class: "text-blue-600 hover:text-blue-800 hover:underline"
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" to view their DNS records. ", -1))
      ]),
      content: _withCtx(() => [
        _cache[24] || (_cache[24] = _createElementVNode("h1", { class: "text-3xl mt-14" }, "Dns lookup", -1)),
        _cache[25] || (_cache[25] = _createElementVNode("p", null, "Online nslookup is a web based DNS client that queries DNS records for a given domain name. It allows you to view all the DNS records for a website. It provides the same information as command line tools like dig and nslookup, from the convenience of your web browser.", -1)),
        _cache[26] || (_cache[26] = _createElementVNode("p", null, "Nslookup.io does not cache the DNS responses it shows, but the DNS servers that are queried usually do respond with a cached record set. Except for authoritative DNS servers. They never serve cached DNS records.", -1)),
        _cache[27] || (_cache[27] = _createElementVNode("h2", null, "How does online nslookup work?", -1)),
        _cache[28] || (_cache[28] = _createElementVNode("p", null, "Using nslookup online is very simple. Enter a domain name in the search bar above and hit 'enter'. This will take you to an overview of DNS records for the domain name you specified. Behind the scenes, NsLookup.io will query a DNS server for DNS records without caching the results.", -1)),
        _createElementVNode("p", null, [
          _cache[12] || (_cache[12] = _createTextVNode("You can select from a range of DNS servers on the result page. These include popular public DNS servers, the authoritative DNS server for the given domain, and local DNS servers all around the world. By default, only ", -1)),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/a/" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("A", -1)
            ]))]),
            _: 1
          }),
          _cache[13] || (_cache[13] = _createTextVNode(", ", -1)),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/aaaa/" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("AAAA", -1)
            ]))]),
            _: 1
          }),
          _cache[14] || (_cache[14] = _createTextVNode(", ", -1)),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/cname/" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("CNAME", -1)
            ]))]),
            _: 1
          }),
          _cache[15] || (_cache[15] = _createTextVNode(", ", -1)),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/txt/" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("TXT", -1)
            ]))]),
            _: 1
          }),
          _cache[16] || (_cache[16] = _createTextVNode(", ", -1)),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/ns/" }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("NS", -1)
            ]))]),
            _: 1
          }),
          _cache[17] || (_cache[17] = _createTextVNode(", ", -1)),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/mx/" }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("MX", -1)
            ]))]),
            _: 1
          }),
          _cache[18] || (_cache[18] = _createTextVNode(" and ", -1)),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/soa/" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("SOA", -1)
            ]))]),
            _: 1
          }),
          _cache[19] || (_cache[19] = _createTextVNode(" records are shown, but you can select additional record types. ", -1))
        ]),
        _cache[29] || (_cache[29] = _createElementVNode("h2", null, "Supported DNS record types", -1)),
        _createElementVNode("p", null, [
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/" }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode("DNS has many record types", -1)
            ]))]),
            _: 1
          }),
          _cache[21] || (_cache[21] = _createTextVNode(" that each serve a distinct purpose. However, some of these record types are no longer in use. Wikipedia has a list of ", -1)),
          _cache[22] || (_cache[22] = _createElementVNode("a", {
            href: "https://en.wikipedia.org/wiki/List_of_DNS_record_types#Obsolete_record_types",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "obsolete record types", -1)),
          _cache[23] || (_cache[23] = _createTextVNode(". These obsolete types are not supported by nslookup.io. All the DNS record types that are known to be in active use are supported by nslookup:", -1))
        ]),
        _createElementVNode("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recordTypes), (otherRecordType, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_router_link, {
                to: `/${otherRecordType.lower}-lookup/`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(otherRecordType.upper) + " lookup", 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createTextVNode(" — " + _toDisplayString(otherRecordType.description), 1)
            ]))
          }), 128))
        ]),
        _cache[30] || (_cache[30] = _createElementVNode("h2", null, "Use cases for online DNS lookup", -1)),
        _cache[31] || (_cache[31] = _createElementVNode("p", null, "There are many situations where online nslookup can be a useful tool. For example, when you are configuring the DNS records of your own domain, you might want to check whether you have configured them correctly. You can do this by entering the domain name at the top of this page.", -1)),
        _cache[32] || (_cache[32] = _createElementVNode("p", null, "Whenever you change DNS records, it takes a while for it to propagate through the entire domain name system. This takes time because DNS servers cache records in order to speed up DNS resolution. So whenever you change DNS records, you can check whether they have propagated yet by doing a DNS lookup.", -1)),
        _cache[33] || (_cache[33] = _createElementVNode("p", null, "There are of course more use cases for online nslookup, instead of using a CLI. Those include being able to share the results with a colleague or friend, and the ability to see multiple record types at the same time, without querying multiple times.", -1))
      ]),
      _: 1
    }, 8, ["domainSearchToUrl"])
  ], 64))
}
}

})